import React, { FC, forwardRef } from "react";

import {
  RouterLink,
  RouterLinkProps,
} from "@Libs/Router/Components/RouterLink/RouterLink";

// eslint-disable-next-line react/display-name
export const FooterLink: FC<RouterLinkProps> = forwardRef<HTMLAnchorElement>(
  (props, ref) => {
    return <RouterLink ref={ref} textDecoration="none" {...props} />;
  }
);
